import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import { Spin, Table, Typography } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import { GetInvoiceTemplateApi } from "../../../api/request/invoice";

const { Title } = Typography;

const ViewInvoice = ({ isOpen, setIsOpen, selectedTemplate }) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getInvoiceTemplate = async (id) => {
    try {
      setIsLoading(true);
      const { data } = await GetInvoiceTemplateApi({
        invoice_template_id: id,
      });
      if (data.status) setData(data?.data);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTemplate?.id && isOpen) getInvoiceTemplate(selectedTemplate?.id);
  }, [selectedTemplate, isOpen]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      align: "center",
      render: (text) => text || "--",
    },
    {
      title: "Charge",
      dataIndex: "charge",
      key: "charge",
      align: "right",
      render: (value) => (
        <p className="text-green-600 font-bold">${Number(value).toFixed(2)}</p>
      ),
    },
  ];

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      width={800}
      className="top-[50px]"
    >
      {isLoading ? (
        <div className="flex justify-center items-center">
          <Spin />
        </div>
      ) : (
        <div className="bg-white h-[700px] overflow-y-auto space-y-5">
          <div className="flex justify-between border-b pb-4">
            <Title level={2} className="text-right">
              Invoice
            </Title>
          </div>

          <div>
            <Title level={3} className="m-0">
              {data?.business_name}
            </Title>

            <p>GST:{data?.admin?.gst_no}</p>

            <div className="text-gray-600 mb-5">
              {data?.address?.split(",")?.map((item) => (
                <p>{item},</p>
              ))}
            </div>

            <p>Phone: {data?.phone_no || data?.admin?.mobile_no || "--"}</p>

            <a href={`mailto:${data?.admin?.email}`} className="text-blue-500">
              {data?.admin?.email}
            </a>
          </div>

          <div>
            <p className="sub-title">TO:</p>
            <p>{data?.admin?.name}</p>
          </div>

          <p className="text-right block text-gray-600">
            {moment(data?.created_at).format("LL")}
          </p>

          <div>
            <p>
              <span className="text-base">Hello,</span> {data?.admin?.name}.
            </p>
            <p>This is your invoice for {data?.name}.</p>
          </div>

          <div>
            <Title level={4}>Itemized Bill:</Title>
            <Table
              dataSource={data?.title ? JSON.parse(data.title) : []}
              columns={columns}
              pagination={false}
              bordered
            />
          </div>

          <div className="text-right text-lg font-bold">
            <p>Total (Incl. Tax): ${Number(data.amount).toFixed(2)}</p>
          </div>

          <p>{data?.remark}</p>

          <div className="text-center text-gray-500 text-sm">
            <p>Thank you for your business!</p>
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

export default ViewInvoice;
